import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'uxd-design-system-components';
import './StyledModal.scss';

/* 
  Reusable Component meant to mimick the style of the Vue modal
*/

const StyledModal = ({
  headerText,
  paragraphText,
  buttonText,
  displayModal,
  closeModalHandler,
}) => {
  const button = {
    text: buttonText,
    onClick: closeModalHandler,
    styleVariant: 'primary',
  };
  return (
    <Dialog
      title={headerText}
      open={displayModal}
      buttons={[button]}
      onRequestClose={closeModalHandler}
    >
      <div className="modal-container">
        <p className="modal-paragraph">{paragraphText}</p>
      </div>
    </Dialog>
  );
};

StyledModal.propTypes = {
  headerText: PropTypes.string.isRequired,
  paragraphText: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  displayModal: PropTypes.bool.isRequired,
  closeModalHandler: PropTypes.func.isRequired,
};

export default StyledModal;
